import $ from 'jquery';
import {formatMoney} from '@shopify/theme-currency';
import * as cart from '@shopify/theme-cart';
import axios from 'axios';

import {misc as icons} from '../helpers/svg-map';
import cssClasses from '../helpers/cssClasses';

import {quantitySelector, quantitySelectorTemplate} from './quantity-selector';

function setBusListeners() {
  Karmoon.EventBus.listen(
    ['AddToCart:itemRemoved', 'AddToCart:itemAdded', 'Cart:itemAdded'],
    () => {
      getCartJson();
    },
  );

  Karmoon.EventBus.listen(['AddToCart:isRemoving', 'Cart:isUpdating'], () => {
    cartUpdating();
  });

  Karmoon.EventBus.listen('Cart:updated', (cartData) => {
    cartUpdated();
    rebuildCart(cartData);
  });
}

function setEventListeners() {
  getCartJson();
}

function rebuildCart(cartData) {
  cartRender(cartData);
  cartCounter(cartData);
  updateTotal(cartData);
}

/**
 * Ajax call to get all cart data json.
 */
function getCartJson() {
  axios
    .get('/cart.js?no-cache}')
    .then((response) => {
      Karmoon.EventBus.emit('Cart:updated', response.data);
    })
    .catch((error) => {
      window.console.error(error);
      return error;
    });
}

/**
 * Handle quantity updates.
 * @param {HTMLElement} element - Quantity selector node element.
 */
function handleQuantityEvent(element) {
  Karmoon.EventBus.emit('Cart:isUpdating');

  const data = {
    index: element.closest(selectors.lineItem).dataset.index,
    key: element.closest(selectors.lineItem).dataset.key,
    quantity: parseInt(element.querySelector('input').value, 10),
  };

  cart
    .updateItem(data.key, {quantity: data.quantity})
    .then(() => {
      Karmoon.EventBus.emit('Cart:itemAdded');
    })
    .catch((error) => {
      if (typeof response === 'undefined') {
        return;
      }

      throw new Error('Could not update item data', error);
    });
}

/**
 * Instantiate quantity selectors using id.
 * - Callback has a timer to reduce number of calls.
 */
function constructQuantitySelectors() {
  const quantitySelectors = document.querySelectorAll(
    selectors.quantitySelector,
  );

  [...quantitySelectors].forEach((item) => {
    quantitySelector(`${item.id}`, () => {
      window.clearTimeout(window.timer);
      window.timer = window.setTimeout(() => {
        handleQuantityEvent(item);
      }, 250);
    }).init();
  });
}

/**
 * Build cart template
 * @param {Object} data - Cart data.
 */
function cartRender(data) {
  const cartItems = data.items;

  // console.log(cartItems);

  const countMap = cartItems.map((item) => {
    return item.quantity;
  });

  const sum = countMap.reduce(add, 0);

  function add(accumulator, a) {
    return accumulator + a;
  }

  let countText = '';
  if (sum === 0) {
    countText = '';
  } else if (sum === 1) {
    countText = `${sum} item`;
  } else {
    countText = `${sum} items`;
  }

  // console.log(countText);

  const cartCountAll = document.querySelector('.cart-count-all');

  cartCountAll.innerHTML = countText;

  // FIX: When window.location.assign is active, the whole site forwards directly to the cart with no interaction from the user. This is an infinite loop and doesn't stop until memory leak error!
  if (cartItems.length) {
    const cartTemplate = getCartTemplate(data);
    nodeSelectors.itemList.innerHTML = cartTemplate;
  } else {
    // window.location.assign('/cart');
  }

  constructQuantitySelectors();
}

/**
 * Get cart template
 * @param {Object} data - Cart data.
 * @returns {String}
 */
function getCartTemplate(data) {
  const lineItemsTemplate = data.items
    .map((item, index) => getLineItemTemplate(item, index))
    .join('');

  return `${lineItemsTemplate}`;
}

/**
 * Return line item HTML block.
 * @param {Object} item - Cart item.
 * @param {interger} index - Index count.
 * @returns {HTMLElement}
 */
function getLineItemTemplate(item, index) {
  const cartVariantTitle = getVariantTitle(item);
  const cartLinePrice = getLinePrice(item);
  const createQuantitySelector = quantitySelectorTemplate(item, index);
  const isolate = getAcf(item);

  // console.log(item);
  // console.log(`ISOLATE: ${isolate}`);

  const cartRow = `
            <div
              class="cart__row cart-data"
              data-key="${item.key}"
              data-index="${index}"
              js-cart-table="lineItem"
            >
              <div class="cart__image">
                <a href="${item.url}" title="${item.product_title}">
                  <img src="${item.image}" />
                </a>
              </div>

              <div class="cart__content">
                <a href="${item.url}" title="${item.product_title}">
                  <h5 class="cart-item__title"><span>${item.vendor}</span><br />${item.product_title}</h5>

                </a>

                ${cartVariantTitle}
              </div>

              <div class="cart__details">
                <div class="cart-item__quanity-wrapper">
                  <span class="cart-item__detail-title">Quantity</span>
                  ${createQuantitySelector}
                </div>

                <div class="cart-item__subtotal">
                  <span class="cart-item__detail-title">Subtotal</span>
                  ${cartLinePrice}
                </div>

                <div class="cart-item__remove">
                  <button
                    js-cart="remove"
                    data-item-key="${item.key}"
                    name="Remove"
                    type="button"
                    class="cart-ajax__remove"
                    tabindex="0">
                  ${icons.remove}
                </button>
                </div>

              </div>
            </div>`;

  return cartRow;
}

/**
 * Return Variant title if avaible.
 * @param {Object} item - Cart item.
 * @returns {HTMLElement}
 */
function getVariantTitle(item) {
  return item.variant_title === null
    ? ''
    : `<p class="cart-item__variant">${item.variant_title}</p>`;
}

function getAcf(item) {
  let isoImg = '';
  $.ajax({
    type: 'GET',
    async: false,
    url: `/products/${item.handle}?view=accentuate.json`,
    dataType: 'html',
    success(productData) {
      isoImg = parseAcf(productData);
      // console.log(`ISOIMG: ${isoImg}`);
    },
    error() {
      console.log('Error occured');
    },
  });

  return isoImg;
}

function parseAcf(productData) {
  const html = $.parseHTML(productData);
  const body = $(html).text();
  const json = JSON.parse(body);
  const isolate = json.isolate_image;
  // console.log(body);

  return isolate;
}

/**
 * Return formatted line item price.
 * @param {Object} item - Cart item.
 * @returns {HTMLElement}
 */
function getLinePrice(item) {
  const cartLinePrice = formatMoney(item.line_price, theme.moneyFormat).replace(
    '.00',
    '',
  );

  return cartLinePrice;
}

/**
 * Update total items in cart counter.
 * @param {Object} data - Cart data.
 */
function cartCounter(data) {
  [...nodeSelectors.counter].forEach((item) => {
    item.innerHTML = data.item_count;

    if (data.item_count === 0) {
      item.classList.remove(cssClasses.active);
    } else {
      item.classList.add(cssClasses.active);
    }
  });
}

/**
 * Update total cart price.
 * @param {Object} data - Cart data.
 */
function updateTotal(data) {
  // const cartTotal = formatMoney(data.total_price, theme.moneyFormat).replace(
  //   '.00',
  //   '',
  // );

  const cartTotal = formatMoney(data.total_price, theme.moneyFormat);

  [...nodeSelectors.totalPrice].forEach((item) => {
    item.innerHTML = `<span class=money>${cartTotal}</span>`;
  });
}

/**
 * Add loading state when adding to cart.
 */
function cartUpdating() {
  nodeSelectors.container.classList.add(cssClasses.loading);
}

/**
 * Remove loading state from Ajax cart.
 */
function cartUpdated() {
  if (nodeSelectors.container) {
    nodeSelectors.container.classList.remove(cssClasses.loading);
  }
}

const selectors = {
  container: '[js-cart="container"]',
  cart: '[js-cart="cart"]',
  cartHeader: '[js-ajax-cart="header"]',
  quantity: '[js-cart="quantity"]',
  quantitySelector: '[js-cart="quantitySelector"]',
  itemList: '[js-cart="list"]',
  totalPrice: '[js-cart="totalPrice"]',
  counter: '[js-ajax-cart="counter"]',
  lineItem: '[js-cart-table="lineItem"]',
};

const nodeSelectors = {
  container: document.querySelector(selectors.container),
  cart: document.querySelector(selectors.cart),
  cartHeader: document.querySelector(selectors.cartHeader),
  quantity: [...document.querySelectorAll(selectors.quantity)],
  totalPrice: [...document.querySelectorAll(selectors.totalPrice)],
  counter: [...document.querySelectorAll(selectors.counter)],
  itemList: document.querySelector(selectors.itemList),
  lineItem: document.querySelector(selectors.lineItem),
};

// Export default Main Cart.
export default () => {
  function init() {
    if (document.body.classList.contains('template-cart')) {
      setBusListeners();
      setEventListeners();
    }
  }

  return Object.freeze({
    init,
  });
};
